import { getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_BASE = `${getProxyApiUrl()}/crm/v3/objects`;
export const getObject = data => noAuthClient.get(`${API_BASE}/${data.objectType}/${data.objectId}${data.properties ? `?properties=${data.properties.join(',')}` : ''}`);
export function searchObject(data, delay) {
  return noAuthClient.post(`${API_BASE}/${data.objectType}/search`, Object.assign({
    data
  }, delay && {
    delay
  }));
}
export const createCrmObject = ({
  data,
  objectType
}) => noAuthClient.post(`${API_BASE}/${objectType}`, {
  data
});
export const createCrmObjectBatch = ({
  data,
  objectType
}) => noAuthClient.post(`${API_BASE}/${objectType}/batch/create`, {
  data: {
    inputs: data
  }
});